import { ReactNode } from 'react';

import { Box, Flex, keyframes } from '@chakra-ui/react';

type AutoSliderProps = {
  speed?: number; // speed in seconds per full scroll
  children: ReactNode[];
};

export const AutoSlider = ({ speed = 90, children }: AutoSliderProps) => {
  const duplicatedChildren = [...children, ...children];

  const scroll = keyframes`
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  `;

  return (
    <Box
      w="100vw"
      overflow="hidden"
      mb="120px"
      _hover={{ animationPlayState: 'paused' }} // hover pause
    >
      <Flex
        w="fit-content"
        animation={`${scroll} ${speed}s linear infinite`}
        _hover={{ animationPlayState: 'paused' }}
        sx={{
          '& > *': {
            flexShrink: 0,
          },
        }}
      >
        {duplicatedChildren.map((child, index) => (
          <Box key={`slide_${index}`}>{child}</Box>
        ))}
      </Flex>
    </Box>
  );
};
